var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"迁徙图","visible":_vm.mapDialog,"fullscreen":true,"width":"90%"},on:{"close":function($event){return _vm.$emit('update:mapDialog', false)}}},[_c('arc-map',_vm._b({ref:"myMap"},'arc-map',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }